import { httpPost } from './utils';

const api = {
  fetchList: (url, body) => httpPost(url, body),
  reviewAlert: (url, body) => httpPost(url, body),
  closeAlert: (url, body) => httpPost(url, body),
};

export default api;
